import evt from 'event'

var Geolocation = {
  location: {},
  getLocation: function () {
    var promise = new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.location.latitude = position.coords.latitude
          this.location.longitude = position.coords.longitude
          resolve(this.location)
        }, (error) => {
          reject(error)
        }, {
          timeout: 5000
        })
      } else {
        reject()
      }
    })
    return promise
  }
}

evt.mixin(Geolocation)

export default Geolocation



// WEBPACK FOOTER //
// ./src/mods/Geolocation.js